import s from "./style.module.scss";
import clsx from "clsx";
import { Icon16Cancel } from "@vkontakte/icons";
import { Files } from "@/core/reatom/state/currentService/currentService";
import { MessageFiles } from "../MessageFiles/MessageFiles";

interface ReplyProps {
  replyName?: string;
  replyTextShort?: string;
  onClick?: () => void;
  cancelReply?: () => void;
  files?: Files[];
}
export const Reply = (props: ReplyProps) => {
  const { replyName, replyTextShort, cancelReply, onClick, files } = props;
  // if (!replyName && !replyTextShort && !files) {
  //   return null;
  // }
  return (
    <div
      className={clsx(
        s.reply,
        cancelReply && s.replyMessage,
        onClick && s.clickable
      )}
      onClick={onClick}
    >
      <div className={s.greenLine} />
      <div className={s.replyWrapper}>
        <div>
          <p className={s.replyName}>{replyName}</p>
          <p className={s.replyText}> {replyTextShort}</p>
          <div className={s.downloads}>
            {!!files?.length &&
              (cancelReply ? (
                <>
                  <MessageFiles file={files[0]} />
                </>
              ) : (
                <>
                  {files?.map((file) => (
                    <MessageFiles key={file.id} file={file} />
                  ))}
                </>
              ))}
          </div>
        </div>
        {cancelReply && (
          <button onClick={cancelReply}>
            <Icon16Cancel color="var(--icons-green)" />
          </button>
        )}
      </div>
    </div>
  );
};
